<template>
    <div class="trend-chart-wrapper">
        <ECharts class="v-echarts" :options="line" autoresize />
    </div>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";

export default {
    name: "TrendChart",
    props: ["data"],
    components: {
        ECharts
    },
    data() {
        return {
            line: null
        };
    },
    computed: {
        pv() {
            return this.$t("zhiji.serviceData.pv");
        },
        uv() {
            return this.$t("zhiji.serviceData.uv");
        },
        robotUv() {
            return this.$t("zhiji.serviceData.robotUv");
        },
        ticketCreateUser() {
            return this.$t("zhiji.serviceData.ticketCreateUser");
        },
        ticketCreateNum() {
            return this.$t("zhiji.serviceData.ticketCreateNum");
        },
        ticketHandleNum() {
            return this.$t("zhiji.serviceData.ticketHandleNum");
        },
        ticketHandleUser() {
            return this.$t("zhiji.serviceData.ticketHandleUser");
        }
    },
    watch: {
        data() {
            this.line = this.getOptions();
        }
    },
    methods: {
        getOptions() {
            return {
                color: ["#8093ff", "#b29cff", "#3fbdff", "#fddb50", "#ff9900", "#ff886e", "#2ac682"],
                legend: {
                    data: [
                        {
                            name: this.pv, // 服务闭环次数
                            icon: "circle"
                        },
                        {
                            name: this.uv, // 服务闭环用户数
                            icon: "circle"
                        },
                        {
                            name: this.robotUv, // 机器人服务闭环用户数
                            icon: "circle"
                        },
                        {
                            name: this.ticketCreateNum, // 工单生成量
                            icon: "circle"
                        },
                        {
                            name: this.ticketCreateUser, // 生成工单用户数
                            icon: "circle"
                        },
                        {
                            name: this.ticketHandleNum, // 工单处理量
                            icon: "circle"
                        },
                        {
                            name: this.ticketHandleUser, // 处理工单用户数
                            icon: "circle"
                        }
                    ],
                    left: 0,
                    itemGap: 20
                },
                tooltip: {
                    trigger: "axis",
                    textStyle: {
                        align: "left"
                    }
                },
                grid: {
                    left: "40",
                    right: "60",
                    bottom: "20",
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            show: false
                        }
                    }
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    axisLine: {
                        lineStyle: {
                            color: "#B2BBDF"
                        }
                    },
                    axisLabel: {
                        color: "#41475e",
                        padding: [8, 0, 0, 0]
                    },
                    data: this.data.xAxisData
                },
                yAxis: {
                    type: "value",
                    axisLine: {
                        show: false,
                        symbol: "none"
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "dashed",
                            color: "#ECF1F7"
                        }
                    }
                },
                series: this.getSeries({
                    pv: this.data.pv, // 服务闭环次数
                    uv: this.data.uv, // 服务闭环用户数
                    robotUv: this.data.robotUv, // 机器人服务闭环用户数
                    ticketCreateNum: this.data.ticketCreateNum, // 工单生成量
                    ticketCreateUser: this.data.ticketCreateUser, // 生成工单用户数
                    ticketHandleNum: this.data.ticketHandleNum, // 工单处理量
                    ticketHandleUser: this.data.ticketHandleUser // 处理工单用户数
                })
            };
        },
        getSeries(datas) {
            const lines = [
                {
                    name: this.pv,
                    color: "#8093ff",
                    id: "pv"
                },
                {
                    name: this.uv,
                    color: "#b29cff",
                    id: "uv"
                },
                {
                    name: this.robotUv,
                    color: "#3fbdff",
                    id: "robotUv"
                },
                {
                    name: this.ticketCreateNum,
                    color: "#fddb50",
                    id: "ticketCreateNum"
                },
                {
                    name: this.ticketCreateUser,
                    color: "#ff9900",
                    id: "ticketCreateUser"
                },
                {
                    name: this.ticketHandleNum,
                    color: "#ff886e",
                    id: "ticketHandleNum"
                },
                {
                    name: this.ticketHandleUser,
                    color: "#2ac682",
                    id: "ticketHandleUser"
                }
            ];

            return lines.map(function(line) {
                return {
                    name: line.name,
                    type: "line",
                    smooth: true,
                    itemStyle: {
                        normal: {
                            lineStyle: {
                                color: line.color
                            }
                        }
                    },
                    data: datas && datas[line.id] ? datas[line.id] : []
                };
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.trend-chart-wrapper {
    height: 400px;
    width: 100%;
    margin-bottom: 35px;

    .v-echarts {
        width: 100%;
        height: calc(100% - 20px);
    }
}
</style>
